import { action } from 'easy-peasy';

import { IActionSetTeamMembersLocation } from '../types';

const setTeamMembersLocation: IActionSetTeamMembersLocation = action((state, payload) => {
  state.teamMembersLocation.items = payload;
});

export default setTeamMembersLocation;
